export default function GradientSparkleFilled() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.111 13.7688C12.1335 12.6448 11.3625 11.8738 10.2385 6.89634C10.187 6.66884 9.9845 6.50684 9.7505 6.50684C9.5165 6.50684 9.314 6.66884 9.2625 6.89634C8.138 11.8738 7.3675 12.6448 2.39 13.7688C2.162 13.8208 2 14.0228 2 14.2568C2 14.4908 2.162 14.6928 2.39 14.7448C7.3675 15.8693 8.138 16.6403 9.2625 21.6173C9.314 21.8448 9.5165 22.0068 9.7505 22.0068C9.9845 22.0068 10.187 21.8448 10.2385 21.6173C11.363 16.6403 12.1335 15.8693 17.111 14.7448C17.339 14.6928 17.5005 14.4908 17.5005 14.2568C17.5005 14.0228 17.3385 13.8208 17.111 13.7688Z"
        fill="url(#paint0_linear_3336_9718)"
      />
      <path
        d="M21.6106 6.01963C18.9646 5.42213 18.5931 5.05063 17.9956 2.40512C17.9436 2.17712 17.7416 2.01562 17.5076 2.01562C17.2736 2.01562 17.0716 2.17712 17.0196 2.40512C16.4221 5.05063 16.0506 5.42213 13.4051 6.01963C13.1771 6.07163 13.0156 6.27363 13.0156 6.50763C13.0156 6.74163 13.1771 6.94363 13.4051 6.99563C16.0506 7.59313 16.4221 7.96463 17.0196 10.6106C17.0716 10.8381 17.2736 11.0001 17.5076 11.0001C17.7416 11.0001 17.9436 10.8381 17.9956 10.6106C18.5931 7.96463 18.9646 7.59313 21.6106 6.99563C21.8381 6.94363 22.0001 6.74163 22.0001 6.50763C22.0001 6.27363 21.8381 6.07163 21.6106 6.01963Z"
        fill="url(#paint1_linear_3336_9718)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3336_9718"
          x1="17.5005"
          y1="14.0987"
          x2="-7.99951"
          y2="13.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5BE0DC" />
          <stop offset="1" stop-color="#060081" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3336_9718"
          x1="20.0002"
          y1="7"
          x2="2.00024"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5BE0DC" />
          <stop offset="1" stop-color="#060081" />
        </linearGradient>
      </defs>
    </svg>
  );
}
